
import { SET_BUSINESS_PROFILE, SET_USER_PROFILE } from './actionTypes';

const initialState = {
    userProfile: {},
    businessProfile: {}
};

const profile = (state = initialState, action) => {
    switch (action.type) {
        
        case SET_USER_PROFILE:
            state = { ...state, userProfile: action.payload };
            break;
        case SET_BUSINESS_PROFILE:
            state = { ...state, businessProfile: action.payload };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default profile;
